import { Component, inject, computed} from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { TranslocoPipe } from '@ngneat/transloco';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { AVAILABLE_LANGUAGES, LANGUAGE_TRANSLATION_KEY } from '@shared/models';
import { LanguageService } from '@shared/services';

@Component({
  selector: 'app-route-form-footer',
  standalone: true,
  imports: [CommonModule, NgFor, TranslocoPipe, MatInputModule, MatSelectModule],
  templateUrl: './route-form-footer.component.html',
  styleUrls: ['./route-form-footer.component.scss']
})
export class RouteFormFooterComponent {

  public languageService = inject(LanguageService);
  public availableLanguages = AVAILABLE_LANGUAGES;
  public languageKey = LANGUAGE_TRANSLATION_KEY;
  public selectedLanguage = this.languageService.currentLanguage;
  public imageSrc = computed(() => this.getImgSource(this.selectedLanguage()));

  public getTranslatedLanguage(language: string) {
    return this.languageService.getTranslation(`${this.languageKey}.${language}`);
  }

  public getImgSource(language: string) {
    return `assets/img/${language}.svg`;
  }

}
